import clsx from 'clsx';

import { Icon } from '@components';
import { ICON_SIZE_PX, IconSize } from '@components/icon/Icon';

const isUrl = (value: string) =>
  value.startsWith('http://') || value.startsWith('https://');

interface DynamicIconProps {
  name: string;
  color: string;
  size?: IconSize;
  className?: string;
}

const DynamicIcon = ({
  name,
  color,
  size = 'medium',
  className
}: DynamicIconProps) => {
  if (isUrl(name)) {
    const px = ICON_SIZE_PX[size] ?? ICON_SIZE_PX.medium;
    return (
      <img
        src={name}
        alt=""
        className={className}
        style={{ width: px, height: px }}
      />
    );
  }

  return (
    <span
      className={clsx('icon-color-override inline-flex', className)}
      style={{ '--icon-color': color } as React.CSSProperties}
    >
      <Icon name={name} size={size} stroke={color} />
    </span>
  );
};

export default DynamicIcon;
